import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import * as commonStyles from '../../components/common.style';
export var browsePage = /*#__PURE__*/css("padding:0 10px;", media('>=desktop'), "{padding:0;}");
export var title = commonStyles.mainTitle;